.asset-bar {
  font-size: 14px;
  line-height: 1.4285714286;
}

@media screen and (min-width: 980px) {
  .asset-bar {
    padding: 14px 24px 0;
    border: 1px solid #e7e6e6;
    border-radius: 4px;
    display: flex;
  }
}

@media screen and (min-width: 980px) {
  .asset-bar-columns-count-7 {
    flex: 0 0 100%;
    flex-wrap: nowrap;
    flex-direction: column;
  }

  :host(:not([dir="rtl"])) .asset-bar-columns-count-7 {
    padding-right: 0;
  }

  :host([dir="rtl"]) .asset-bar-columns-count-7 {
    padding-left: 0;
  }
}

@media screen and (min-width: 980px) {
  .asset-bar__documents-list {
    display: flex;
    flex-flow: wrap;
    height: 100%;
  }
}

@media screen and (min-width: 980px) {
  .asset-bar-firmware-display {
    display: block;
    flex-direction: column;
    flex-wrap: wrap;
    width: 100%;
  }
}

.document-item {
  width: 100%;
  display: flex;
  cursor: pointer;
  text-decoration: none;
  margin-top: 10px;
}

.document-item-wrapper {
  padding-left: 16px;
  padding-right: 16px;
  margin-bottom: 24px;
}

@media screen and (min-width: 980px) {
  .document-item-wrapper {
    box-sizing: border-box;
    display: flex;
    flex: 0 0 25%;
  }

  :host(:not([dir="rtl"])) .document-item-wrapper {
    padding-left: 0;
  }

  :host([dir="rtl"]) .document-item-wrapper {
    padding-right: 0;
  }

  :host(:not([dir="rtl"])) .document-item-wrapper:nth-child(4n) {
    padding-right: 0;
  }

  :host([dir="rtl"]) .document-item-wrapper:nth-child(4n) {
    padding-left: 0;
  }

  .asset-bar__documents-list--columns-count-1 .document-item-wrapper {
    flex: 0 0 100%;
  }

  :host(:not([dir="rtl"])) .asset-bar__documents-list--columns-count-1 .document-item-wrapper {
    padding-right: 0;
  }

  :host([dir="rtl"]) .asset-bar__documents-list--columns-count-1 .document-item-wrapper {
    padding-left: 0;
  }

  .asset-bar__documents-list--columns-count-2 .document-item-wrapper {
    flex: 0 0 50%;
  }

  :host(:not([dir="rtl"])) .asset-bar__documents-list--columns-count-2 .document-item-wrapper:nth-child(2n) {
    padding-right: 0;
  }

  :host([dir="rtl"]) .asset-bar__documents-list--columns-count-2 .document-item-wrapper:nth-child(2n) {
    padding-left: 0;
  }
}

.document-item__label-with-icon {
  width: 100%;
  display: flex;
}

@media screen and (min-width: 980px) {
  .document-item__label-with-icon {
    display: block;
  }
}

.document-item__label {
  color: #333333;
}

@media screen and (min-width: 980px) {
  :host(:not([dir="rtl"])) .document-item__label {
    padding-right: 22px;
  }

  :host([dir="rtl"]) .document-item__label {
    padding-left: 22px;
  }
}

:host(:not([dir="rtl"])) .document-item__icon-action {
  margin-left: auto;
}

:host([dir="rtl"]) .document-item__icon-action {
  margin-right: auto;
}

@media screen and (min-width: 980px) {
  .document-item__icon-action {
    margin-top: 3px;
    color: #42b4e6;
  }

  :host(:not([dir="rtl"])) .document-item__icon-action {
    margin-left: -18px;
  }

  :host([dir="rtl"]) .document-item__icon-action {
    margin-right: -18px;
  }
}

.document-item__icon-type {
  width: 14px;
  height: 20px;
  background-position-x: center;
  background-size: cover;
  background-repeat: no-repeat;
  flex-shrink: 0;
  color: #42b4e6;
}

:host(:not([dir="rtl"])) .document-item__icon-type {
  margin-right: 8px;
}

:host([dir="rtl"]) .document-item__icon-type {
  margin-left: 8px;
}

.asset-bar-document-heading {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
}

.asset-bar-document-heading--single {
  flex-shrink: 1;
}

.document-heading {
  width: 89px;
  height: 60px;
  top: 1140px;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 40px;
  color: #333;
}

:host(:not([dir="rtl"])) .document-heading {
  left: 150px;
}

:host([dir="rtl"]) .document-heading {
  right: 150px;
}

.latest-firmware__heading {
  width: 126px;
  height: 40px;
  top: 1140px;
  font-family: "Arial Rounded MT Bold", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 40px;
  color: #333;
}

:host(:not([dir="rtl"])) .latest-firmware__heading {
  left: 749px;
}

:host([dir="rtl"]) .latest-firmware__heading {
  right: 749px;
}

.link {
  margin-bottom: 24px;
  align-self: flex-start;
}

@media screen and (max-width: 979px) {
  :host(:not([dir="rtl"])) .link {
    padding-left: 16px;
  }

  :host([dir="rtl"]) .link {
    padding-right: 16px;
  }
}